import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { createQuery } from '@farfetched/core';
import { getSourceTypes } from './api';
import type { GetSourceTypesResponse } from './types';

export const SourceTypesControlGate = createGate();

const fxGetSourceTypes = createEffect<void, GetSourceTypesResponse, Error>().use(
  getSourceTypes
);

export const sourceTypesQuery = createQuery({
  name: 'SourceTypes',
  effect: fxGetSourceTypes,
  mapData: ({ result }) =>
    Array.isArray(result?.sources)
      ? result.sources.map((item) => ({
          id: item?.title,
          label: item?.title ?? '',
        }))
      : [],
});

sample({
  clock: SourceTypesControlGate.open,
  source: SourceTypesControlGate.status,
  filter: (status) => Boolean(status),
  target: sourceTypesQuery.start,
});
